<template>
  <div style="background: #fff">
    <headers />
    <div class="head">
      <img src="@/assets/images/communityBj.png" />

      <div class="headTit">新闻中心</div>
      <div class="searchBox">
        <search @search="searchFun" :type="2" />
      </div>

      <div class="headBomBox">
        <div class="headBomBoxItem" @click="actTabChange(1)">
          <div class="tabTit" :style="{ color: actTab == 1 ? '#ffffff' : '' }">
            新闻资讯
          </div>
          <div
            class="tabLine"
            :class="{ 'tabLine--hidden': actTab != 1 }"
          ></div>
        </div>
        <div class="headBomBoxItem" @click="actTabChange(2)">
          <div class="tabTit" :style="{ color: actTab == 2 ? '#ffffff' : '' }">
            产品公告
          </div>
          <div
            class="tabLine"
            :class="{ 'tabLine--hidden': actTab != 2 }"
          ></div>
        </div>
      </div>
    </div>

    <div class="breadcrumb" :key="itemKey">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{
          actTab == 1 ? "新闻资讯" : "产品公告"
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 分类：仅新闻资讯展示（占位避免切换 tab 时列表上跳） -->
    <div class="newsCategory" :class="{ 'newsCategory--hidden': actTab != 1 }">
      <button
        v-for="item in categoryList"
        :key="item.id"
        type="button"
        class="newsCategoryItem"
        :class="{ 'newsCategoryItem--active': activeCategoryId === item.id }"
        @click="onCategoryChange(item)"
      >
        {{ item.name }}
      </button>
    </div>

    <!-- 新闻资讯/产品公告列表 -->
    <div class="listWrap">
      <transition name="school-loading-fade">
        <div v-if="listLoading" class="school-loading-overlay">
          <div class="school-loading-inner">
            <svg
              class="school-loading-svg"
              viewBox="0 0 48 48"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <circle
                class="school-loading-track"
                cx="24"
                cy="24"
                r="20"
                fill="none"
                stroke-width="3"
              />
              <circle
                class="school-loading-arc"
                cx="24"
                cy="24"
                r="20"
                fill="none"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
            <p class="school-loading-text">加载中</p>
          </div>
        </div>
      </transition>

      <template v-if="list.length">
        <div class="content">
          <div
            class="card"
            v-for="(item, index) in list"
            :key="index"
            @click="toNewsDetails(item)"
          >
            <div class="cardImg">
              <img :src="item.image" />
            </div>
            <div class="cardImgRBox" v-if="actTab == 1">
              <div class="cardTit textOverflowOne">
                {{ item.title }}
              </div>
              <div class="cardTime">发布时间：{{ item.createTime }}</div>
              <div class="cardTextArea textOverflowTwo">
                {{ item.intro }}
              </div>
              <!-- 权益等级标签列表 -->
              <div
                v-if="
                  item.equityClassifyNames && item.equityClassifyNames.length
                "
              >
                <div
                  class="newsTag"
                  style="background: rgba(0, 216, 195, 0.1); color: #00d8c3"
                >
                  {{
                    String(item.equityClassifyNames || "").replace(/,/g, "/")
                  }}可查看
                </div>
              </div>
            </div>

            <div class="cardImgRBox" v-if="actTab == 2">
              <div class="card2Tit textOverflowTwo">
                {{ item.title }}
              </div>
              <div class="card2BomBox">
                <div class="card2Btn">查看详情</div>
                发布时间：{{ item.createTime }}
              </div>
            </div>
          </div>
        </div>

        <div class="page">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="pages.total"
            :current-page="pages.page"
            :page-size="pages.size"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
      </template>

      <None v-else />
    </div>
    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import search from "@/components/search.vue";

import { newsInfoList, newsNoticeList, getNewsClassifyList } from "@/api/lx";
export default {
  name: "news",
  components: {
    headers,
    footers,
    search,
  },
  data() {
    return {
      searchValue: "",
      list: [],
      itemKey: Math.random(),
      actTab: 1,
      pages: {
        page: 1,
        total: 0,
        size: 10,
      },
      /** 当前选中的新闻分类 id，空字符串表示“全部” */
      activeCategoryId: "",
      /** 新闻分类列表，初始化仅包含“全部”选项，后续通过接口动态追加 */
      categoryList: [{ id: "", name: "全部" }],
      categoryLoading: false,
      listLoading: false,
      listRequestId: 0,
      minLoadingTime: 500,
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.actTab = to.query.id;
    this.fetchCategoryList();
    this.getList();
    next();
  },
  created() {
    this.actTab = this.$route.query.id;
    this.fetchCategoryList();
    this.getList();
  },
  mounted() {},
  methods: {
    toNewsDetails(item) {
      // 校验是否有权限查看详情（新闻资讯 actTab 为 1 且 canView 为 false 时提示权益不够）
      if (this.actTab == 1 && item.canView === false) {
        this.$message.warning("暂无访问权益");
        return;
      }
      this.$router.push({
        path: "/news/details",
        query: { id: item.id, actTab: this.actTab },
      });
    },
    actTabChange(val) {
      this.actTab = val;
      // if (this.actTab == 2) {
      //   this.$router.replace({
      //     path: "/login",
      //     replace: true,
      //   });
      //   return;
      // }
      this.pages.page = 1;
      if (this.actTab == 1) {
        this.fetchCategoryList();
      }
      this.getList();
    },

    /** 切换新闻分类 */
    onCategoryChange(item) {
      if (this.activeCategoryId === item.id) return;
      this.activeCategoryId = item.id;
      this.pages.page = 1;
      this.getList();
    },

    /**
     * 拉取新闻分类列表并拼装“全部”选项
     */
    fetchCategoryList() {
      if (this.actTab != 1) return;
      this.categoryLoading = true;
      getNewsClassifyList()
        .then((res) => {
          if (res.code == 200) {
            const list = res.data || [];
            // 在返回的新闻分类列表首位拼装“全部”分类选项，其 ID 传空
            this.categoryList = [{ id: "", name: "全部" }, ...list];
            // 若 activeCategoryId 仍为初始值 null/undefined，默认选中第一个“全部” (id 为 "")
            if (
              this.activeCategoryId === null ||
              this.activeCategoryId === undefined
            ) {
              this.activeCategoryId = "";
            }
          } else {
            this.$message.error(res.msg || "获取分类列表失败");
          }
        })
        .catch(() => {
          this.$message.error("获取新闻分类列表失败");
        })
        .finally(() => {
          this.categoryLoading = false;
        });
    },

    currentChange(val) {
      this.pages.page = val;
      this.getList();
    },
    searchFun(val) {
      console.log(";1231");
      this.searchValue = val;
      this.pages.page = 1;
      this.getList();
    },
    getList() {
      const requestId = ++this.listRequestId;
      const startTime = Date.now();
      this.listLoading = true;

      const promise =
        this.actTab == 1
          ? newsInfoList({
              page: this.pages.page,
              size: this.pages.size,
              title: this.searchValue,
              // 新闻分类 ID 过滤参数名变更为 newsClassifyId
              newsClassifyId: this.activeCategoryId,
            })
          : newsNoticeList({
              page: this.pages.page,
              size: this.pages.size,
              title: this.searchValue,
            });

      promise
        .then((res) => {
          if (requestId !== this.listRequestId) return;
          this.list = res.data.records;
          this.pages.total = res.data.total;
        })
        .finally(() => {
          if (requestId !== this.listRequestId) return;
          const remain = this.minLoadingTime - (Date.now() - startTime);
          const delay = remain > 0 ? remain : 0;
          setTimeout(() => {
            if (requestId !== this.listRequestId) return;
            this.listLoading = false;
          }, delay);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  width: 100%;
  height: 300px;
  position: relative;
  overflow: hidden;
  .headTit {
    width: 100%;
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 42px;
    color: #ffffff;
    position: relative;
    z-index: 1;
    margin-top: 70px;
  }
  .searchBox {
    margin-top: 34px;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.headBomBox {
  position: absolute;
  left: 0;
  bottom: 2px;
  width: 100%;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  .headBomBoxItem {
    width: 80px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin: 0 110px;
    font-weight: 400;
    font-size: 20px;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.7);
    .tabTit {
      width: 86px;
      text-align: center;
    }
  }
  .tabLine {
    width: 72px;
    height: 3px;
    flex-shrink: 0;
    background: #ffffff;
    &--hidden {
      background: transparent;
    }
  }
}
.newsCategory {
  width: 100%;
  // max-width: 1200px;
  margin: 0 24px 0;
  margin-top: 30px;
  min-height: 44px;
  &--hidden {
    visibility: hidden;
    pointer-events: none;
  }
  padding: 0 24px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  // justify-content: center;
  align-items: center;
  gap: 8px;
}
.newsCategoryItem {
  display: inline-flex;
  align-items: center;
  padding: 6px 16px;
  border-radius: 999px;
  border: 1px solid #e6edf0;
  background: #fff;
  font-family: PingFangSC, PingFang SC;
  font-size: 14px;
  font-weight: 400;
  color: #525f66;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  &:hover {
    border-color: #00d8c3;
    color: #00d8c3;
  }
  &--active {
    border-color: #00d8c3;
    background: #00d8c3;
    color: #fff;
    font-weight: 600;
    &:hover {
      color: #fff;
    }
  }
}
.newsCategoryBadge {
  margin-left: 6px;
  padding: 0 6px;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  border-radius: 4px;
  background: #f7d358;
  font-size: 12px;
  font-weight: 700;
  color: #00161a;
  text-align: center;
}
.content {
  width: 100%;
  box-sizing: border-box;
  padding-left: 6px;
  box-sizing: border-box;
  padding-top: 30px;
  min-height: 400px;
  display: flex;
  flex-wrap: wrap;
  .card {
    width: 894px;
    height: 186px;
    background: #f9f9f9;
    border: 1px solid #e6edf0;
    margin-left: 38px;
    margin-bottom: 38px;
    display: flex;
    box-sizing: border-box;
    .cardImg {
      width: 330px;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .cardImgRBox {
      width: 542px;
      height: 100%;
      padding: 20px;
      padding-right: 11px;
      // padding-top: 32px;
      box-sizing: border-box;
      .cardTit {
        width: 100%;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 24px;
        color: #00161a;
      }
      .cardTime {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #829199;
        margin-top: 10px;
      }
      .newsTag {
        display: inline-flex;
        padding: 0 7px;
        margin-top: 4px;
        height: 25px;
        background: #935de4;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        line-height: 25px;
      }
      .cardTextArea {
        width: 100%;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #525f66;
        margin-top: 12px;
      }
      .card2Tit {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 24px;
        line-height: 33px;
        color: #00161a;
        height: 66px;
      }
      .card2BomBox {
        display: flex;
        align-items: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #525f66;
        margin-top: 13px;
        .card2Btn {
          width: 104px;
          height: 39px;
          text-align: center;
          line-height: 39px;
          background: #00d8c3;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 14px;
          color: #ffffff;
          margin-right: 20px;
        }
      }
    }
  }
}

.page {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 65px;
}
.listWrap {
  min-height: 400px;
  position: relative;
}
.school-loading-overlay {
  position: fixed;
  top: 74px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2001;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
.school-loading-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}
.school-loading-svg {
  width: 44px;
  height: 44px;
  animation: school-loading-spin 0.9s linear infinite;
}
.school-loading-track {
  stroke: rgba(0, 216, 195, 0.18);
}
.school-loading-arc {
  stroke: #00d8c3;
  stroke-dasharray: 80 46;
  stroke-dashoffset: 0;
}
.school-loading-text {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: #2b3339;
  letter-spacing: 0.5px;
}
.school-loading-fade-enter-active,
.school-loading-fade-leave-active {
  transition: opacity 0.28s ease;
}
.school-loading-fade-enter,
.school-loading-fade-leave-to {
  opacity: 0;
}
@keyframes school-loading-spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>